import dayjs from 'dayjs';

export const formatDateTime = (date: string): string => {
  const parsed = dayjs(date);
  if (!parsed.isValid()) {
    return 'Invalid date';
  }

  return parsed.format('DD.MM.YYYY HH:mm');
};
